export const KEYWORD_PRODUCT_COUNT = { PAGE_1: 45, TOP_3_PAGES: 135 };
